import { useBatchReveal } from "../animations/hooks";
import React from "react";
import ModalCentered from "./ModalCentered";
import { getCareerData } from "../helpers/StaticData/careerData";
import { useTranslation } from "react-i18next";
function CareerJobPosition(props) {
    const [modalData, setModalData] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    const {t} = useTranslation();
    const careerData = getCareerData();
    const gridRef = useBatchReveal({ stagger: 0.1 }, [props?.type]);
    const showDescriptionModal = (item) => {
        setModalData(item);
        setShowModal(true);
    }
    // if(showModal) return (
    //     <ModalCentered
    //     onHide = {setShowModal}
    //     title = {modalData?.title}
    //     modalData = {modalData}
    //     />
    // )
    return (
        
        <>
        {
            showModal ?
            <ModalCentered
            onHide = {setShowModal}
            title = {modalData?.title}
            modalData = {modalData}
            />
            : ""
        }
        <div className="row" ref={gridRef}>
            {
                careerData && careerData.map((item, index) => (
                    item.type == props?.type ?
                        <div className="col-md-6 col-lg-3" data-reveal key={index}>
                            <div className="staff-container staff-container-mobile">
                                <img className="img_career" src="assets/img/career/career.png" alt="career" />
                                <div className="staff-body p-0 mt-0 h-100">
                                    <h5 className="staff-title text-center">
                                        {item.title}
                                    </h5>
                                    <button type="button" className="position-description mb-3" onClick={()=>showDescriptionModal(item)}>
                                        {t("positionDescription")}
                                    </button>
                                    <a className="btn btn-primary btn-black w-100" target="_blank"
                                    href="https://docs.google.com/forms/d/e/1FAIpQLSeHEvNbbs-n4bKJskm1LCbSTSdJV33gcjtQ7qH1rihzShPI5w/viewform?usp=publish-editor">{t("applyNow")}</a>
                                </div>
                            </div>
                        </div>
                    : ""
                ))
            }
        </div>
        </>
    )
}
export default CareerJobPosition;